module.exports = __webpack_public_path__ + "img/5-5.d687daf2.svg";